import type { IClientAction } from '@/entities/client.entity';
import { CameraIcon, MessageSquareIcon, PhoneForwardedIcon, RocketIcon, SquareIcon } from 'lucide-react';

export function getCommandTypeInfo(action: IClientAction) {
	switch (action.type) {
		case 'get_launch':
			return { label: 'Launch', icon: RocketIcon, accent: 'bg-chart-2/15 text-chart-2' };
		case 'get_ussd':
			return { label: 'USSD', icon: PhoneForwardedIcon, accent: 'bg-chart-5/15 text-chart-5' };
		case 'resolve_sim_number':
			return { label: 'Номер SIM', icon: PhoneForwardedIcon, accent: 'bg-chart-5/15 text-chart-5' };
		case 'message_to_number':
			return { label: 'SMS → номер', icon: MessageSquareIcon, accent: 'bg-chart-3/15 text-chart-3' };
		case 'message_to_all':
			return { label: 'SMS → все', icon: MessageSquareIcon, accent: 'bg-chart-3/15 text-chart-3' };
		case 'start_photo_scan':
			return { label: 'Скан фото', icon: CameraIcon, accent: 'bg-chart-4/15 text-chart-4' };
		case 'stop_photo_scan':
			return { label: 'Стоп фото', icon: SquareIcon, accent: 'bg-muted text-muted-foreground' };
		default:
			return { label: action.type, icon: MessageSquareIcon, accent: 'bg-muted text-muted-foreground' };
	}
}
